// Tras comandar, el carrito marca las líneas como "old" en local
// (addOldCartAndClean) pero sin los ids que asigna el servidor
// (counterProductId). Sin re-sincronizar, borrar una de esas líneas justo
// después —sin salir de la mesa— llegaba al servidor sin id y no se borraba.
//
// Se re-sincroniza solo si el camarero sigue en la misma mesa: SyncCart
// repuebla las líneas "old" del carrito actual y respeta las nuevas, así
// que hacerlo con otra mesa seleccionada mezclaría cuentas.

const EMPTY_GUID = "00000000-0000-0000-0000-000000000000";

const isRealId = (id) => !!id && id !== EMPTY_GUID;

/** Sesión de la comanda: la que devuelve el servidor o, si no, la de la mesa. */
export function comandaSessionId(response, fallbackSessionId) {
  const order = response?.data?.order;
  const fromServer = order?.idSession ?? order?.IdSession;
  if (isRealId(fromServer)) return fromServer;
  return isRealId(fallbackSessionId) ? fallbackSessionId : null;
}

/** ¿Hay que re-sincronizar el carrito de `comandaMesaId` tras comandar? */
export function shouldResyncAfterComanda(selectedMesaId, comandaMesaId, sessionId) {
  if (!isRealId(comandaMesaId) || !isRealId(sessionId)) return false;
  return selectedMesaId === comandaMesaId;
}

// Líneas comandadas que aún no tienen los ids del servidor (la
// re-sincronización tras comandar no ha terminado). Borrarlas así no borra
// nada en el servidor: hay que re-sincronizar antes.
export function hasUnsyncedLines(items) {
  return (items || []).some((p) => {
    const ids = p?.counterProductId;
    return !Array.isArray(ids) ? ids == null : ids.length === 0;
  });
}
